import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import StarIcon from "@material-ui/icons/Star";
import TwitterIcon from "@material-ui/icons/Twitter";
import ReplyIcon from "@material-ui/icons/Reply";
import LaunchIcon from "@material-ui/icons/Launch";
import RepeatIcon from "@material-ui/icons/Repeat";
import PeopleIcon from "@material-ui/icons/People";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import dayjs from "dayjs";
import useFilter from "Hooks/useFilter";
import { fromMonthly, toMonthly } from "fuction/date";
import replaceMediaText from "fuction/replaceMediaText";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
  header: {
    display: "flex",
    justifyContent: "flex-start",
    listStyle: "none",
    "& > li": {
      marginRight: 5,
    },
    lineHeight: "20px",
    marginBottom: "0.5em",
    paddingLeft: 0,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    listStyle: "none",
    "& > li": {
      marginLeft: 5,
    },
  },
  postDate: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 10,
    marginRight: 10,
  },
  mediaType: {
    padding: "0 5px",
    color: "#fff",
  },
  headLine: {
    overflow: "hidden",
    marginBottom: "0.5em",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%",
    fontSize: "1.2rem",
    fontWeight: "600",
  },
  text: {
    whiteSpace: "pre-wrap",
    marginBottom: "0.5em",
  },
  url: {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "300px",
  },
  book: {
    position: "absolute",
    right: 15,
    top: 15,
  },
  isPrimaryHideBook: {
    width: '100%',
    textAlign: 'right',
  },
  rtCount: {
    position: "absolute",
    right: 50,
    top: 18,
    color: "#f00",
    fontSize: 16,
  },
  imgList: {
    display: "flex",
    flexWrap: "wrap",
  },
  img: {
    marginRight: "5px",
  },
  MuiDividerInset: {
    marginRight: 0,
  }
}));

export default function Media({ row, types, order}) {
  const filter = useFilter();
  const classes = useStyles();
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);

  // barカラー設定
  const barColor = {
    0: "#535c68",
    1: "#eb4d4b",
    2: "#4834d4",
    3: "#f9ca24",
    4: "#badc58",
    5: "#f0932b",
    6: "#7ed6df",
    7: "#ff7979",
    8: "#6ab04c",
    9: "#30336b",
    10: "#e056fd",
  }

  // カテゴリごとの色を配色
  const typeColor = ((typeLavel) =>{ 
    let color = "000";

    types.map((type) => {
      if (type.label == typeLavel) {
        // color = barColor[type.id]
        color = type.color
      }
    });

    return color;
  });

  return (
    <List className={classes.root}>
      <ListItem alignItems="flex-start">
        <ListItemText
          primary={
            <React.Fragment>
              <Typography
                component="p"
                variant="body2"
                color="textPrimary"
                className={classes.headLine}
              >
                {row['Headline']}
              </Typography>
              <ul className={classes.header}>
                <li>
                  <Typography
                    component="p"
                    variant="body2"
                    color="textPrimary"
                    className={classes.mediaType}
                    style={{
                      border: "1px solid " + typeColor(row['Media Type']),
                      backgroundColor: typeColor(row['Media Type']),
                    }}
                  >
                    {row['Media Type']}
                  </Typography>
                </li>
                <li>
                  <Typography
                    component="p"
                    variant="body2"
                    className={classes.inline}
                    color="textPrimary"
                  >
                    {row['Source']} / {row['Influencer']}
                  </Typography>
                </li>
              </ul>
            </React.Fragment>
          }
          secondary={
            <React.Fragment>
              <Typography
                component="p"
                variant="body2"
                color="textPrimary"
                className={classes.text}
              >
                {replaceMediaText(row['Hit Sentence'])}
              </Typography>
              <ul className={classes.footer}>
                <li>
                  <Typography
                    component="p"
                    variant="body2"
                    className={classes.inline}
                    color="textPrimary"
                  >
                    <a className={classes.url} href={row['URL']} target="_blank" rel="noopener noreferrer">
                      {row['URL']}
                    </a>
                  </Typography>
                </li>
                <li>
                  <p className={classes.postDate}>
                    {dayjs(row['Date']).format("YYYY/MM/DD HH:mm:ss")}
                  </p>
                </li>
              </ul>
            </React.Fragment>
          }
        />
      </ListItem>
      {/* <Divider variant="inset" component="li" /> */}
      <Divider variant="fullWidth" component="li" />
    </List>
  );
}
